const REGION_LABELS = {
  "北海道・東北": "Hokkaido / Tohoku",
  "関東": "Kanto",
  "甲信越・北陸": "Koshinetsu / Hokuriku",
  "東海": "Tokai",
  "関西": "Kansai",
  "中国・四国": "Chugoku / Shikoku",
  "九州・沖縄": "Kyushu / Okinawa",
};

const PREFECTURE_LABELS = {
  "北海道": "Hokkaido",
  "青森県": "Aomori",
  "岩手県": "Iwate",
  "宮城県": "Miyagi",
  "秋田県": "Akita",
  "山形県": "Yamagata",
  "福島県": "Fukushima",
  "茨城県": "Ibaraki",
  "栃木県": "Tochigi",
  "群馬県": "Gunma",
  "埼玉県": "Saitama",
  "千葉県": "Chiba",
  "東京都": "Tokyo",
  "神奈川県": "Kanagawa",
  "新潟県": "Niigata",
  "富山県": "Toyama",
  "石川県": "Ishikawa",
  "福井県": "Fukui",
  "山梨県": "Yamanashi",
  "長野県": "Nagano",
  "岐阜県": "Gifu",
  "静岡県": "Shizuoka",
  "愛知県": "Aichi",
  "三重県": "Mie",
  "滋賀県": "Shiga",
  "京都府": "Kyoto",
  "大阪府": "Osaka",
  "兵庫県": "Hyogo",
  "奈良県": "Nara",
  "和歌山県": "Wakayama",
  "鳥取県": "Tottori",
  "島根県": "Shimane",
  "岡山県": "Okayama",
  "広島県": "Hiroshima",
  "山口県": "Yamaguchi",
  "徳島県": "Tokushima",
  "香川県": "Kagawa",
  "愛媛県": "Ehime",
  "高知県": "Kochi",
  "福岡県": "Fukuoka",
  "佐賀県": "Saga",
  "長崎県": "Nagasaki",
  "熊本県": "Kumamoto",
  "大分県": "Oita",
  "宮崎県": "Miyazaki",
  "鹿児島県": "Kagoshima",
  "沖縄県": "Okinawa",
};

const INDUSTRY_LABELS = {
  "IT": "IT",
  "製造": "Manufacturing",
  "小売": "Retail",
  "飲食": "Food service",
  "建設": "Construction",
  "不動産": "Real estate",
  "医療・福祉": "Medical and welfare",
  "教育": "Education",
  "サービス": "Services",
  "金融": "Finance",
  "農業，林業": "Agriculture and forestry",
  "漁業": "Fisheries",
  "鉱業，採石業，砂利採取業": "Mining and quarrying",
  "建設業": "Construction",
  "製造業": "Manufacturing",
  "電気・ガス・熱供給・水道業": "Utilities",
  "情報通信業": "Information and communications",
  "運輸業，郵便業": "Transport and postal services",
  "卸売業，小売業": "Wholesale and retail trade",
  "金融業，保険業": "Finance and insurance",
  "不動産業，物品賃貸業": "Real estate and rental/leasing",
  "学術研究，専門・技術サービス業": "Professional and technical services",
  "宿泊業，飲食サービス業": "Accommodation and food services",
  "生活関連サービス業，娯楽業": "Lifestyle services and entertainment",
  "教育，学習支援業": "Education and learning support",
  "医療，福祉": "Medical, health care and welfare",
  "複合サービス事業": "Compound services",
  "サービス業（他に分類されないもの）": "Services, n.e.c.",
  "公務（他に分類されるものを除く）": "Government",
  "分類不能の産業": "Unclassified industries",
  "ソフトウェア開発": "Software development",
  "ITコンサルティング": "IT consulting",
  "クラウドサービス": "Cloud services",
  "電子機器": "Electronics",
  "自動車": "Automotive",
  "機械設備": "Machinery and equipment",
  "化学": "Chemicals",
  "食品製造": "Food manufacturing",
  "繊維製品": "Textile products",
  "オンライン小売": "Online retail",
  "店舗小売": "Store retail",
  "卸売": "Wholesale",
  "ディスカウントショップ": "Discount retail",
  "レストラン・カフェ": "Restaurants and cafes",
  "フードデリバリー": "Food delivery",
  "ベーカリー": "Bakery",
  "住宅建設": "Residential construction",
  "商業施設建設": "Commercial construction",
  "インフラ・土木": "Infrastructure and civil engineering",
  "リフォーム": "Renovation",
  "不動産開発": "Real estate development",
  "不動産賃貸・管理": "Real estate leasing and management",
  "不動産仲介": "Real estate brokerage",
  "不動産投資": "Real estate investment",
  "病院・診療所": "Hospitals and clinics",
  "介護施設": "Elder care facilities",
  "ヘルスケアサービス": "Healthcare services",
  "医療機器製造": "Medical device manufacturing",
  "薬局": "Pharmacy",
  "学校・大学": "Schools and universities",
  "学習塾・予備校": "Tutoring and prep schools",
  "オンライン教育": "Online education",
  "専門学校": "Vocational schools",
  "コンサルティング": "Consulting",
  "物流・配送": "Logistics and delivery",
  "広告・マーケティング": "Advertising and marketing",
  "エンターテイメント": "Entertainment",
  "美容・健康": "Beauty and wellness",
  "銀行": "Banking",
  "証券": "Securities",
  "保険": "Insurance",
  "投資": "Investment",
  "フィンテック": "Fintech",
};

const BUSINESS_TAG_LABELS = {
  "BtoB": "B2B",
  "BtoC": "B2C",
  "D2C": "D2C",
  "EC": "E-commerce",
  "SaaS": "SaaS",
  "サブスクリプション": "Subscription",
  "メーカー": "Manufacturer",
  "卸売": "Wholesale",
  "広告": "Advertising",
  "マッチング": "Matching platform",
  "仲介": "Intermediary",
  "フランチャイズ": "Franchise",
  "プラットフォーム": "Platform",
  "システム開発": "System development",
  "受託": "Contract services",
  "コンサルティング": "Consulting",
  "運営代行": "Operations outsourcing",
  "人材派遣": "Staffing",
  "人材紹介": "Recruitment agency",
  "プロダクト販売": "Product sales",
  "直販": "Direct sales",
  "小売": "Retail",
  "代理店": "Agency / reseller",
  "OEM": "OEM",
  "ODM": "ODM",
  "上場企業": "Public company",
  "中小企業": "SMB",
  "ベンチャー": "Venture company",
  "老舗": "Long-established company",
  "スタートアップ": "Startup",
  "グローバル": "Global",
  "DX支援": "DX support",
  "業務効率化": "Operational efficiency",
  "Web制作": "Web production",
  "アプリ開発": "App development",
  "AI": "AI",
  "生成AI": "Generative AI",
  "採用支援": "Recruiting support",
  "営業代行": "Sales outsourcing",
  "BPO": "BPO",
  "アウトソーシング": "Outsourcing",
  "マーケティング支援": "Marketing support",
  "広告代理店": "Advertising agency",
  "Webマーケティング": "Web marketing",
  "SEO": "SEO",
  "SNS運用": "Social media operations",
  "ECサイト": "E-commerce site",
  "越境EC": "Cross-border e-commerce",
  "物流": "Logistics",
  "倉庫": "Warehousing",
  "製造": "Manufacturing",
  "食品": "Food",
  "建設": "Construction",
  "不動産": "Real estate",
  "医療": "Medical",
  "介護": "Elder care",
  "福祉": "Welfare",
  "教育": "Education",
  "研修": "Training",
  "セキュリティ": "Security",
  "クラウド": "Cloud",
  "IoT": "IoT",
  "データ分析": "Data analytics",
  "CRM": "CRM",
  "MA": "Marketing automation",
  "SFA": "SFA / sales force automation",
  "ERP": "ERP",
  "RPA": "RPA",
};

const splitTaxonomyTokens = (value) =>
  String(value || "")
    .split(/[、,，]/)
    .map((token) => token.trim())
    .filter(Boolean);

export const getOperatorTaxonomyLabel = (value, type) => {
  if (!value) return "";
  const normalizedValue = String(value).trim();
  if (!normalizedValue) return "";

  if (type === "region") return REGION_LABELS[normalizedValue] || "";
  if (type === "prefecture") return PREFECTURE_LABELS[normalizedValue] || "";
  if (type === "address") return REGION_LABELS[normalizedValue] || PREFECTURE_LABELS[normalizedValue] || "";
  if (type === "industry") return INDUSTRY_LABELS[normalizedValue] || "";
  if (type === "businessTag") return BUSINESS_TAG_LABELS[normalizedValue] || "";
  return "";
};

export const getOperatorTaxonomySearchText = (value, type) => {
  const labels = [
    getOperatorTaxonomyLabel(value, type),
    ...getOperatorTaxonomyLabelsFromText(value, type),
  ].filter(Boolean);
  return [value, ...labels].join(" ");
};

export const getOperatorTaxonomyLabelsFromText = (value, type, maxLabels = 4) => {
  const labels = [];
  for (const token of splitTaxonomyTokens(value)) {
    const label = getOperatorTaxonomyLabel(token, type);
    if (label && !labels.includes(label)) labels.push(label);
    if (labels.length >= maxLabels) break;
  }
  return labels;
};

export const getOperatorPrefectureLabelFromAddress = (address) => {
  const addressText = String(address || "");
  if (!addressText) return "";
  const prefecture = Object.keys(PREFECTURE_LABELS).find((pref) => addressText.includes(pref));
  return prefecture ? PREFECTURE_LABELS[prefecture] : "";
};
